import React from 'react'

import { Element } from '@Components/Elements/Types'
import { RTEContent } from '@Components/RTEContent'
import { convertRTEToHTML } from '@Globals/CMS/FieldHelpers'

export const ElementTypographyRTE = ({ appearance, rte }: Extract<Element, { __typename: 'ElementTypographyRTE' }>) => (
  <RTEContent
    html={convertRTEToHTML(rte)}
    style={{
      backgroundColor: appearance?.backgroundColor || undefined,
      color: appearance?.textColor || undefined,
      fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
    }}
  />
)
